import { render, staticRenderFns } from "./ass-sys-rule.vue?vue&type=template&id=53b17654"
import script from "./ass-sys-rule.vue?vue&type=script&lang=js"
export * from "./ass-sys-rule.vue?vue&type=script&lang=js"
import style0 from "./ass-sys-rule.vue?vue&type=style&index=0&id=53b17654&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports